import styled from 'styled-components';

const COLORS = {
  white: '#ffffff',
  ligthGrey: '#E0E0E0',
  focusColor: '#01bfa5',
};

const Label = styled.label`
  color: ${COLORS.darkGrey};
  display: flex;
  flex-direction: column;
  font-family: 'Montserrat';
  font-weight: 600;
  margin-bottom: 23px;
  position: relative;
  width: 100%;

  transition: border-color 0.2s ease-in-out;
  -webkit-appearance: none;

  ${({ customStyle }) => {
    return customStyle;
  }};

  span {
    position: absolute;
    color: ${COLORS.labelSmall};
    font-size: 1.2em;
    top: -4px;
    background: white;
    padding: 0px 5px;
    left: 10px;
  }
`;

const InputWrapper = styled.div`
  .DlocalField {
    padding: 14px 15px;
    border-radius: 16px;
    border: 2px solid ${COLORS.ligthGrey};
    transition: border-color 0.2s ease-in-out;

    &.DlocalField--focus {
      border-color: ${COLORS.focusColor};
    }
  }
`;
// input,
//   select {
//     border: 2px solid ${COLORS.ligthGrey};
//     border-radius: 16px;
//     color: ${COLORS.darkGrey};
//     font-size: 1.7em;
//     padding: 12px 15px;
//     transition: border-color 0.2s ease-in-out;
//     -webkit-appearance: none;

//     &:focus {
//       border-color: ${COLORS.focusColor};
//     }

//     &:not([type='select']):focus + span,
//     &:not([type='select']):not(:placeholder-shown) + span {
//       color: ${COLORS.labelSmall};
//       font-size: 1.2em;
//       top: -11px;
//     }
//   }

//   select {
//     &:invalid + span {
//       color: gray;
//     }
//   }
export { Label, InputWrapper };
